import classes from "./ForgotPassword.module.css";
import clockImg from "../../images/clockImg.jpg";
import emailSentImg from "../../images/emailSentImg.jpg";
import { ActionBtn } from "../../components/buttons/actionBtn/ActionBtn";
import { LoadingSpinner } from "../../components/loadingSpinner/LoadingSpinner";
import { BaseLoginInput } from "../../components/UI/baseLoginInput/BaseLoginInput";
import { BackToLoginBtn } from "../../components/buttons/backToLoginBtn/BackToLoginBtn";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { LanguageSwitcher } from "../../components/languageSwitcher/LanguageSwitcher";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  reqPassReset,
  resetPassReq,
} from "../../redux/requestPassReset/reqPassReset";

export function ForgotPassword() {
  const { status, error } = useSelector((state) => state.resetPassReq);
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { t } = useTranslations();

  const isStatusLoading = status === "loading";
  const isForgotPassBtnDisabled = isStatusLoading || email === "";
  const forgottenPasswordPage = t.forgottenPasswordPage;

  const isStatusError = status === "error";

  useEffect(() => {
    if (isStatusError) {
      setTimeout(() => {
        dispatch(resetPassReq());
      }, 2000);
    }
  }, [status]);

  // Function for resetting password
  function handlePassReset(e) {
    e.preventDefault();
    dispatch(reqPassReset({ email }));
  }

  function handleBackToLoginClick() {
    dispatch(resetPassReq());
  }

  return (
    <section className={`${classes.loginContainer} fadeIn`}>
      <div
        className={classes.logo}
        style={{
          backgroundImage: `url(${
            status === "success" ? emailSentImg : clockImg
          })`,
        }}
      >
        <div className={classes.box}></div>
        <div className={classes.overlay}></div>
      </div>
      <div className={classes.languageSwitcherContainer}>
        <LanguageSwitcher />
      </div>
      {status !== "success" && (
        <form className={classes.forgotPassForm} onSubmit={handlePassReset}>
          <h2>{forgottenPasswordPage.headerText}</h2>
          <div className={classes.formContent}>
            <p>
              {forgottenPasswordPage.message}
              <br />
              {forgottenPasswordPage.instruction}
            </p>

            <BaseLoginInput
              label={forgottenPasswordPage.form.email}
              name={"email"}
              type={"email"}
              value={email}
              onChange={(e) => setEmail(e.target.value.trim())}
            />

            <ActionBtn
              width={"100%"}
              height={"50px"}
              type="submit"
              disabled={isForgotPassBtnDisabled}
              text={
                isStatusLoading ? (
                  <LoadingSpinner black={false} />
                ) : (
                  forgottenPasswordPage.resetPassBtn
                )
              }
            />
          </div>
          <BackToLoginBtn />

          <div
            className={classes.errorMsg}
            style={{
              opacity: isStatusError ? 1 : 0,
              pointerEvents: isStatusError ? "auto" : "none",
            }}
          >
            {error}
          </div>
        </form>
      )}

      {status === "success" && (
        <div className={classes.checkEmail}>
          <h2>{t.passwordReset.heading}</h2>
          <p>
            {t.passwordReset.message + " "}
            <strong>{email}</strong>
          </p>
          <BackToLoginBtn onClick={handleBackToLoginClick} />
        </div>
      )}
    </section>
  );
}
